/* eslint-disable max-classes-per-file */
import {
	WidgetType, EditorView, Decoration, ViewUpdate, ViewPlugin,
} from '@codemirror/view';
import { syntaxTree } from '@codemirror/language';

import './columnWidget.scss';
import { makeNodeName } from '~/components/ktable/utils';

const KNITIV_COLUMN_SELECT_CLASS = 'knitiv-column-select';

/**
	*
	* @param {EditorView} view
	* @param {{ from: number, to: number }} stringRange
	* @param {string} newString
	* @returns
	*/
function updateColumnId(view, stringRange, newString) {
	view.dispatch({ changes: { from: stringRange.from, to: stringRange.to, insert: `"${newString}"` } });
	return true;
}

/**
	*
	* @param {string} string_
	* @returns {string}
	*/
export const removeQuotes = string_ => string_.slice(1, -1);

class ColumnSelect extends WidgetType {
	/** @type {string} */
	value;

	/**
		* @param {string} value
		* @param {import("@knitiv/api-client-javascript").Select[]} infos
		*/
	constructor(value, infos) {
		super();

		this.value = value;
		this.infos = infos;
	}

	// eq(other) {
	// 	return other.value == this.value;
	// }

	toDOM(view) {
		const span = document.createElement('span');
		span.style.margin = '0 2px';
		const wrap = document.createElement('select');
		for (const info of this.infos) {
			wrap.add(new Option(makeNodeName(info, null), info.id));
		}
		wrap.classList.add(KNITIV_COLUMN_SELECT_CLASS);

		wrap.value = this.value;

		wrap.addEventListener('change', event => {
			this.value = wrap.value;

			/** @type {{ target: HTMLSelectElement }} */
			// @ts-ignore
			const { target } = event;
			const { value } = target;

			const pos = view.posAtDOM(target);

			const range = { from: pos, to: -1 };

			// Find the String at the correct position
			syntaxTree(view.state).iterate({
				from: pos,
				enter: node => {
					if (node.name === 'String' && node.from === pos) {
						range.to = node.to;
					}
				},
			});

			return updateColumnId(view, range, value);
		});

		span.append(wrap);

		return span;
	}

	// ignoreEvent() {
	// 	return false;
	// }
}

/**
	*
	* @param {EditorView} view
	* @param {import("@knitiv/api-client-javascript").Select[]} infos
	* @returns
	*/
function findColumns(view, infos) {
	const widgets = [];
	for (const { from, to } of view.visibleRanges) {
		syntaxTree(view.state).iterate({
			from,
			to,
			// eslint-disable-next-line no-shadow
			enter: node => {
				if (
					node.name === 'String'
					&& node.node.parent.parent.name === 'Param'
					&& node.node.parent.parent.prevSibling.name === 'FnKeyword'
				) {
					const text = view.state.doc.sliceString(
						node.node.parent.parent.prevSibling.from,
						node.node.parent.parent.prevSibling.to,
					);

					const string = removeQuotes(view.state.doc.sliceString(
						node.from,
						node.to,
					));

					if (text === 'COLREF') {
						const widget = new ColumnSelect(string, infos);
						const deco = Decoration.replace({
							widget,
							// side: 1,
						});
						widgets.push(deco.range(node.from, node.to));
					}
				}
			},
		});
	}

	return Decoration.set(widgets);
}

/**
	*
	* @param {import("@knitiv/api-client-javascript").Select[]} infos
	* @returns
	*/
export const selectColumn = infos => ViewPlugin.fromClass(
	class {
		/** @type {import("@codemirror/view").DecorationSet} */
		decorations;

		/**
			*
			* @param {EditorView} view
			*/
		constructor(view) {
			this.decorations = findColumns(view, infos);
		}

		/**
			*
			* @param {ViewUpdate} update
			*/
		update(update) {
			if (update.docChanged || update.viewportChanged) {
				this.decorations = findColumns(update.view, infos);
			}
		}
	},
	{
		decorations: v => v.decorations,
		// Consider the widget to be atomic, so that the cursor consider it to be one widget
		provide: plugin => EditorView.atomicRanges.of(view => {
			const value = view.plugin(plugin);
			return value ? value.decorations : Decoration.none;
		}),
	},
);
